import { render, staticRenderFns } from "./MarkdownWidget.vue?vue&type=template&id=d08a7dac&"
import script from "./MarkdownWidget.vue?vue&type=script&lang=js&"
export * from "./MarkdownWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports